"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Thumbnail;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _density = require("@site/pattern-library-utils/density");
var _playButton = _interopRequireDefault(require("../video-lightbox/play-button"));
var _image = require("@site/pattern-library-core/image");
const ClickableThumbnail = /*#__PURE__*/(0, _react2.styled)(_image.LazyBackgroundImage)({
  name: "ClickableThumbnail",
  class: "pl-c18hhpod"
});
const OverlayText = /*#__PURE__*/(0, _react2.styled)("strong")({
  name: "OverlayText",
  class: "pl-o1jwvv6g"
});
const TitleText = /*#__PURE__*/(0, _react2.styled)("p")({
  name: "TitleText",
  class: "pl-t1skz9r0"
});

/**
 * Thumbnail Component
 * @module VideoThumbnail
 *
 * @param {Object} props React props
 * @param {Object} props.thumbnailImage Eyebrow text
 * @param {string} props.playButtonSize Heading text
 * @param {string} props.ariaLabelPlayButton Description text
 * @param {Boolean} props.invertPlayButton Whether to invert the color theme of play button
 * @param {string} props.videoTitle Disclaimer Text
 * @returns {React.ReactElement} YouTube Thumbnail Component
 * @public
 */
function Thumbnail({
  thumbnailImage,
  playButtonSize,
  ariaLabelPlayButton,
  videoTitle,
  invertPlayButton,
  partial,
  onClick
}) {
  const {
    url,
    altText
  } = thumbnailImage;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ClickableThumbnail, {
    "aria-label": altText,
    landscape: url,
    portrait: url,
    onClick: onClick,
    "data-cy": "thumbnail"
  }, /*#__PURE__*/_react.default.createElement(_playButton.default, {
    handlePlay: onClick,
    size: playButtonSize,
    partial: partial || (invertPlayButton ? 'dark1' : ''),
    ariaLabel: ariaLabelPlayButton
  }), videoTitle && /*#__PURE__*/_react.default.createElement(OverlayText, null, videoTitle)), videoTitle && /*#__PURE__*/_react.default.createElement(TitleText, null, videoTitle));
}
Thumbnail.propTypes = {
  thumbnailImage: _propTypes.default.shape(_image.imgPropShape),
  ariaLabelPlayButton: _propTypes.default.string,
  playButtonSize: _propTypes.default.oneOf(['small', 'medium', 'large']),
  videoTitle: _propTypes.default.string,
  invertPlayButton: _propTypes.default.bool,
  partial: _propTypes.default.string,
  onClick: _propTypes.default.func
};